import { NineSlicePlane, Sprite, Texture } from 'pixi.js';

import { Shared } from '../../App';
import { AnimatedButton, defaultAnimatedOpts } from './AnimatedButton';

const defaultOpts = {
    ...defaultAnimatedOpts,
    icon: null as Sprite | Texture | string | null,
    w: 0,
    h: 0,
    scale: 1,
    tint: 0xFFFFFF,
    alpha: 1,
    bgAsset: 'button-ninesliced-yellow',
    nineSliceOffset: 50,
};

export type NineSliceButtonOpts = typeof defaultOpts;

export class NineSliceButton extends AnimatedButton
{
    public view: Sprite;
    public icon: Sprite;
    public bg: NineSlicePlane;

    constructor(opts: Partial<NineSliceButtonOpts> = {})
    {
        const o = { ...defaultOpts, ...opts };

        const view = new Sprite();

        view.anchor.set(0.5);
        view.scale.set(o.scale);
        view.alpha = o.alpha;
        if (o.tint !== 0xFFFFFF) view.tint = o.tint;

        super(view, o);
        this.view = view;

        this.bg = new NineSlicePlane(Shared.assets.getTexture(o.bgAsset),
            o.nineSliceOffset, o.nineSliceOffset, o.nineSliceOffset, o.nineSliceOffset,
        );

        this.bg.width = o.w;
        this.bg.height = o.h;
        this.bg.x -= this.bg.width / 2;
        this.bg.y -= this.bg.height / 2;

        view.addChild(this.bg);

        let icon: Sprite;

        if (o.icon instanceof Sprite)
        {
            icon = o.icon;
        }
        else if (o.icon instanceof Texture)
        {
            icon = Sprite.from(o.icon);
        }
        else if (typeof o.icon === 'string')
        {
            icon = Sprite.from(Shared.assets.getTexture(o.icon));
        }
        else
        {
            icon = new Sprite();
        }

        icon.anchor.set(0.5);
        view.addChild(icon);
        this.icon = icon;
    }
}
